import { render, staticRenderFns } from "./Layout.Footer.vue?vue&type=template&id=dc885778"
import script from "./Layout.Footer.vue?vue&type=script&lang=js"
export * from "./Layout.Footer.vue?vue&type=script&lang=js"
import style0 from "./Layout.Footer.vue?vue&type=style&index=0&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports